import { prettyDate } from './strings';

const dateIsOld = (date: Date | string) => new Date(date) < new Date();

const today = () => prettyDate(new Date());
const tomorrow = () => {
  const today = new Date();
  const tomorrowDay = new Date(today);
  tomorrowDay.setDate(tomorrowDay.getDate() + 1);
  return prettyDate(tomorrowDay);
};

export { dateIsOld, today, tomorrow };
